import { Alert, AlertTitle, Box, Button, Card, CardContent, CardHeader, Chip, DialogContentText, Grid, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Tooltip, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { apiConstants, getDownload, post, postGeneric } from "../../common/constants";
import ProzoDataGrid from "../../common/ProzoDataGrid";
import { formatCurrency, formatDate } from "../../common/util";
import DownloadSharpIcon from '@mui/icons-material/DownloadSharp';
import HistoryIcon from '@mui/icons-material/History';
import { FormProvider, RHFFileField, RHFSelectField, RHFTextField } from "../../common/hook-form";
import { useForm } from "react-hook-form";
import { MerchantFilterCached } from "../../common/ProshipFormComponents";
import _ from "lodash";
import { LoadingButton } from "@mui/lab";
import { useSnackbar } from "notistack";
import MUIModal from "../../components/MuiModal";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { getYear } from "date-fns";
import PageTitle from "../../components/PageTitle";
import { useNavigate } from "react-router-dom";
import VisibilityIcon from '@mui/icons-material/Visibility';
import Loader from "../../common/Loader";
import FileUploadIcon from '@mui/icons-material/FileUpload';
import { yupResolver } from '@hookform/resolvers/yup';
import LibraryAddCheckIcon from '@mui/icons-material/LibraryAddCheck';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import * as Yup from 'yup';


function Invoice() {
    const navigate = useNavigate();
    const methodsFilter = useForm({
        defaultValues: {
            merchant: '',
            status: '',
            month: '',
            year: '',
        }
    });
    const { handleSubmit: handleSubmitFilter, reset: resetForm } = methodsFilter;

    const [page, setPage] = useState(0);
    const [sizePerPage, setSizePerPage] = useState(10);
    const [data, setData] = useState([])
    const [reload, setReload] = useState(0)
    const { enqueueSnackbar } = useSnackbar()
    const [open, setOpen] = useState(false)
    const [approveOpen, setOpenApprove] = useState(false)
    const [uploadOpen, setOpenUpload] = useState(false)
    const [settleOpen, setSettleOpen] = useState(false)
    const [manualUploadOpen, setManualUploadOpen] = useState(false)
    const [correctionsUploadOpen, setCorrectionsUploadOpen] = useState(false)
    const [settleRemark, setSettleRemark] = useState('')
    const [rowData, setRowData] = useState([])
    const [filterData, setFilterData] = useState({ "excludes": "additionalData" });
    const [loading, setLoading] = useState(false);
    const [loadingApprove, setLoadingApprove] = useState(false);

    const months = [{ label: 'January', Value: 1 }, { label: 'February', Value: 2 }, { label: 'March', Value: 3 }, { label: 'April', Value: 4 }, { label: 'May', Value: 5 },
    { label: 'June', Value: 6 }, { label: 'July', Value: 7 }, { label: 'August', Value: 8 }, { label: 'September', Value: 9 }, { label: 'October', Value: 10 }, { label: 'November', Value: 11 }, { label: 'December', Value: 12 }]
    const Status = [{
        label: 'GENERATED',
        value: 'GENERATED'
    },
    {
        label: 'OPS APPROVED',
        value: 'OPS_APPROVED'
    },
    {
        label: 'FINANCE APPROVED',
        value: 'FINANCE_APPROVED'
    },
    {
        label: 'E INVOICED',
        value: 'E_INVOICED'
    },
    {
        label: 'SETTLED',
        value: 'SETTLED'
    }
    ]

    const onSubmitFilter = (data) => {
        function pad(s) { return (s < 10) ? '0' + s : s; }
        var dateFormate = null
        if (data.year && data.month) {
            dateFormate = data.year + pad(data.month)
        }
        if (data.month) {
            const year = getYear(new Date())
            dateFormate = year + pad(data.month)
        }
        setFilterData({
            merchantRef: data?.merchant,
            yearAndMonth: dateFormate,
            "excludes": "additionalData",
            reportStage: data.status
        })
        // setCount({
        //     merchantRef: data?.merchant,
        //     yearAndMonth: dateFormate,
        //     reportStage: data.status
        // })
    }

    useEffect(() => {
        setLoading(true)
        filterData.skip = page * sizePerPage;
        filterData.limit = sizePerPage;
        post(apiConstants.SEARCH_INVOICE, filterData
        ).then((res) => {
            setData(res?.data?.responseObj)
            setLoading(false)
        }).catch((err) => {
            setLoading(false)
        })

    }, [reload, sizePerPage, page, filterData])

    // useEffect(() => {
    //     count.skip = 0;
    //     count.limit = 10000;
    //     post(apiConstants.SEARCH_INVOICE, count).then((res) => {
    //         setRowCountState(res?.data?.responseObj?.length)
    //     })

    // }, [reload, count])

    const handleOpen = (row) => {
        setRowData(row.reverse());
        setOpen(true);
    }
    const handleClose = () => {
        setOpen(false)
        setOpenApprove(false)
        setOpenUpload(false)
        setSettleOpen(false)
        setManualUploadOpen(false)
        setCorrectionsUploadOpen(false)
    }

    const handleCorrectionsUpload = (row) => {
        setRowData(row)
        setCorrectionsUploadOpen(true)
    }

    const handleViewDetails = (row) => {
        navigate(`/invoice-detail/${row.id}/${row.merchantRef}`, {
            state: { Page: 'FINANCE' },
        });
    };

    const columns = [
        {
            field: 'merchantName', headerAlign: "left", align: 'left', hideSortIcons: true, headerName: 'Merchant', flex: 1
        },
        {
            field: 'createdAt', headerAlign: "left", align: 'left', hideSortIcons: true, headerName: 'Created Date', flex: 1,
            renderCell: (params) => {
                const { row } = params;
                return (
                    formatDate(row?.createdAt)
                )
            },
        },
        { field: 'reportFrequency', headerAlign: "left", align: 'left', hideSortIcons: true, headerName: 'Report Frequency', flex: 1 },
        {
            field: 'reportStage', headerAlign: "left", align: 'left', hideSortIcons: true, headerName: 'Status', flex: 1,
            renderCell: (params) => {
                const { row } = params;
                const status = row?.reportStage ? row?.reportStage : '';
                const color =
                    status === 'NEW' ? 'warning' : status === 'SETTLED' ? "primary" : status === 'SETTELED' ? "primary" : status === 'OPS_APPROVED' ? 'info' : status === 'GENERATED' ? 'success' : status === 'PAYMENT_ONGOING' ? 'warning' : "error"
                return (
                    <Chip size="small" color={color} label={status} />
                )
            },
        },
        {
            field: 'fromDate', headerAlign: "left", align: 'left', hideSortIcons: true, headerName: 'From Date', flex: 1,
            renderCell: (params) => {
                const { row } = params;
                return (
                    formatDate(row?.fromDate)
                )
            },
        },
        {
            field: 'toDate', headerAlign: "left", align: 'left', hideSortIcons: true, headerName: 'To Date', flex: 1,
            renderCell: (params) => {
                const { row } = params;
                return (
                    formatDate(row?.toDate)
                )
            },
        },
        {
            field: 'totalOrders', headerAlign: "left", align: 'left', hideSortIcons: true, headerName: 'Total Orders', flex: 0.5,
            renderCell: (params) => {
                const { row } = params;
                return (
                    <>{row?.totalOrders ? row?.totalOrders : 0}</>
                )
            },
        },
        {
            field: 'totalInvoicedAmount', headerAlign: "left", align: 'left', hideSortIcons: true, headerName: 'Invoiced Amount', flex: 0.8,
            renderCell: (params) => {
                const { row } = params;
                return (
                    <>{row?.totalInvoicedAmount ? formatCurrency(row?.totalInvoicedAmount, 0) : formatCurrency(0)}</>
                )
            },
        },
        {
            field: 'avgShipmentPrice', headerAlign: "left", align: 'left', hideSortIcons: true, headerName: 'Avg Shipment Price', flex: 0.8,
            renderCell: (params) => {
                const { row } = params;
                let totalOrders = row?.totalOrders ? row?.totalOrders : 0;
                let totalInvoicedAmount = row?.totalInvoicedAmount ? row?.totalInvoicedAmount : 0;
                let avgShipmentPrice = totalInvoicedAmount / totalOrders;
                return avgShipmentPrice ? formatCurrency(avgShipmentPrice, 0) : formatCurrency(0)
            },
        },
        {
            field: 'view', headerAlign: "left", align: 'left', hideSortIcons: true, headerName: 'View', flex: 1,
            renderCell: (params) => {
                const { row } = params;
                return (
                    <>
                        <Tooltip title="Download Invoice">
                            <IconButton onClick={() => window.open(row?.s3Link?.signedLink)} color="button" size="small">
                                <DownloadSharpIcon fontSize="small" color="primary" />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="View Invoice Details">
                            <IconButton
                                onClick={() => handleViewDetails(row)}
                                color="primary" size="small">
                                <VisibilityIcon fontSize="small" />
                            </IconButton>
                        </Tooltip>
                        {row?.actionLog?.length > 0 &&
                            <Tooltip title="Action Logs">
                                <IconButton color="info" size="small" onClick={() => handleOpen(row?.actionLog)}>
                                    <HistoryIcon fontSize="small" />
                                </IconButton>
                            </Tooltip>}
                        {row?.reportStage === "E_INVOICED" &&
                            <Tooltip title="Download Uploaded E-Invoice">
                                <IconButton onClick={() => window.open(row?.uploadedEInvoiceS3Link?.signedLink)} color="button" size="small">
                                    <DownloadSharpIcon fontSize="small" color="success" />
                                </IconButton>
                            </Tooltip>
                        }
                    </>
                )
            },
        },
        {
            field: 'action', headerAlign: "left", align: 'left', hideSortIcons: true, headerName: 'Action', flex: 1,
            renderCell: (params) => {
                const { row } = params;
                console.log("row?.reportStage", row?.reportStage);
                return (
                    <>
                        <Tooltip title="Approval" >
                            <IconButton onClick={() => handleAgree(row)} color="button" size="small" disabled={row?.reportStage !== 'OPS_APPROVED'}>
                                <CheckCircleIcon fontSize="small" />
                            </IconButton>
                        </Tooltip> <Tooltip title="Upload E invoice" >
                            <IconButton onClick={() => handleUpload(row)} color="info" size="small" disabled={row?.reportStage !== "FINANCE_APPROVED"}>
                                <FileUploadIcon fontSize="small" />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Mark Settle" >
                            <IconButton onClick={() => SettleOpen(row)} color="primary" size="small" disabled={row?.reportStage !== "E_INVOICED"}>
                                <LibraryAddCheckIcon fontSize="small" />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Upload Corrections">
                            <span>
                                <IconButton
                                    disabled={row?.reportStage !== 'GENERATED' && row?.reportStage !== 'OPS_APPROVED'}
                                    onClick={() => handleCorrectionsUpload(row)}
                                    color="primary"
                                    size="small"
                                >
                                    <NoteAddIcon fontSize="small" />
                                </IconButton>
                            </span>
                        </Tooltip>
                    </>
                )
            },
        },
    ]

    const handleAgree = (row) => {
        setRowData(row)
        setOpenApprove(true)
    }
    const handleUpload = (row) => {
        setRowData(row)
        setOpenUpload(true)
    }
    const SettleOpen = (row) => {
        setRowData(row)
        setSettleOpen(true)
    }

    const handleApprove = () => {
        setLoadingApprove(true)
        post(apiConstants.ACTION_INVOICE, {
            "action": "FINANCEAPPROVAL",
            "reportKey": rowData.reportKey,
            "remark": "Finance approving invoice"
        }).then((res) => {
            if (res?.data?.status === "SUCCESS") {
                enqueueSnackbar("Status is Successfully Updated", { variant: 'success' })
                setOpenApprove(false)
                setReload(() => reload + 1)
                setLoadingApprove(false)
            }
            else {
                enqueueSnackbar(res?.data?.errorMsg, { variant: 'error' })
                setOpenApprove(false)
                setLoadingApprove(false)
            }
        }).catch((err) => console.log(err))
    }
    const submitSettle = () => {
        setLoadingApprove(true)
        const payload = {
            "action": "SETTLE",
            "reportKey": rowData.reportKey,
            "remark": settleRemark
        }
        postGeneric(apiConstants.ACTION_INVOICE, payload).then((res) => {
            setLoadingApprove(false)
            if (res.data.status === "SUCCESS") {
                enqueueSnackbar("Successfully Updated", { variant: 'success' })
            }
            handleClose()
            setReload(reload => reload + 1)
        }).catch((err) => {
            setLoadingApprove(false)
            console.log(err);
            enqueueSnackbar("Some error occurred", { variant: 'error' })
            handleClose()
        })
    }
    const columns2 = [
        { field: 'action', headerAlign: "center", align: 'left', hideSortIcons: true, headerName: 'Status', flex: 1 },
        { field: 'remark', headerAlign: "center", align: 'left', hideSortIcons: true, headerName: 'Remarks', width: 250 },
        {
            field: 'actionTime', headerAlign: "center", align: 'center', hideSortIcons: true, headerName: 'Status Date', width: 180,
            renderCell: (params) => {
                const { row } = params;
                return (
                    formatDate(row?.actionTime)
                )
            },
        },
        { field: 'actionedBy', headerAlign: "center", align: 'center', hideSortIcons: true, headerName: 'Action By', width: 200 },

    ]

    return (
        <>
            {loading && <Loader />}
            <PageTitle>Merchant Invoice</PageTitle>
            <MUIModal open={open} handleClose={handleClose} children={<DialogContentText id="alert-dialog-description">
                <ProzoDataGrid
                    columns={columns2}
                    // disableColumnFilter={true}rowsPerPageOptions
                    autoHeight={true}
                    rows={rowData || []}
                    pagination={false}
                    hideFooterPagination={true}
                    filterMode={"server"}
                    rowHeight={60}
                    rowCount={rowData?.length || 0}
                    // hideDisplayRows={"none"}
                    getRowId={(row) => row.action}
                />
            </DialogContentText>}
                title={`Status Logs`} />
            <MUIModal open={approveOpen} handleClose={handleClose} children={<Typography>Are you sure you want to proceed with this Action of Approving the Merchant Invoice as it's a non-reversible action?</Typography>}
                title={"Confirmation"} action={
                    <LoadingButton loading={loadingApprove} onClick={handleApprove} autoFocus color='success' variant="contained">
                        Agree
                    </LoadingButton>}
            />
            <MUIModal open={uploadOpen} handleClose={handleClose} children={<UploadInvoice prop={rowData} handleClose={handleClose} setReload={setReload} setLoadingApprove={setLoadingApprove} />}
                title={"Upload Invoice"}
            />
            <MUIModal open={settleOpen} handleClose={handleClose} children={
                <Grid container spacing={1}>
                    <Grid item xs={12} md={12}>
                        <TextField
                            // InputLabelProps={{
                            //     shrink: true,
                            // }}
                            fullWidth
                            variant="outlined"
                            name="remarkSettle"
                            label="Remark"
                            onChange={(e) => { setSettleRemark(e.target.value) }}
                        />
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <LoadingButton
                            variant="contained"
                            size="medium"
                            loading={loadingApprove}
                            onClick={submitSettle}
                        >Submit</LoadingButton>
                    </Grid>
                </Grid>
            }
                title={"Settle Invoice"}
            />
            <MUIModal open={manualUploadOpen} handleClose={handleClose} children={<ManualUploadInvoice handleClose={handleClose} setReload={setReload} />}
                title={"Upload manually reconciled invoice for merchant"}
            />
            <MUIModal open={correctionsUploadOpen} handleClose={handleClose} children={<UploadCorrections prop={rowData} handleClose={handleClose} setReload={setReload} />}
                title={"Upload Corrections"}
            />
            <Card sx={{ mb: 2 }}>
                <CardHeader
                    action={
                        <Button variant="contained" size="small" color="warning" startIcon={<FileUploadIcon />} onClick={() => setManualUploadOpen(true)}>
                            Upload Invoice
                        </Button>
                    }
                />
                <CardContent>
                    <FormProvider methods={methodsFilter} onSubmit={handleSubmitFilter(onSubmitFilter)}>
                        <Grid container spacing={1} mt={1}>
                            <Grid item xs={12} md={4}>
                                <MerchantFilterCached />
                            </Grid>
                            <Grid item xs={12} md={2}>
                                <RHFSelectField name='status' label="Select Status" options={_.orderBy(Status, "name").map((val) => ({
                                    value: val.value,
                                    label: val.label,
                                }))} width='100%' />
                            </Grid>
                            <Grid item xs={12} md={2}>
                                <RHFSelectField name='month' label="Select Month" options={_.orderBy(months, "name").map((val) => ({
                                    value: val.Value,
                                    label: val.label,
                                }))} width='100%' />
                            </Grid>
                            <Grid item xs={12} md={2}>
                                <RHFTextField name='year' label='Year' />
                            </Grid>
                            <Grid item xs={12} md={2} sx={{ display: 'flex', alignItems: 'center' }}>
                                <LoadingButton
                                    variant="contained"
                                    size="small"
                                    type="submit"
                                >Submit</LoadingButton>
                                <Button onClick={() => {
                                    resetForm({
                                        merchant: null,
                                        status: null,
                                        month: null,
                                        year: null,
                                    })
                                    setFilterData({ "excludes": "additionalData" })
                                    // setCount({})
                                }}
                                    variant="contained" color='error' size="small" sx={{ ml: 1 }}>Reset</Button>


                            </Grid>
                        </Grid>
                    </FormProvider>
                </CardContent>
            </Card>
            <ProzoDataGrid
                columns={columns}
                // disableColumnFilter={true}rowsPerPageOptions
                autoHeight={true}
                rows={data || []}
                sizePerPage={sizePerPage}
                setSizePerPage={setSizePerPage}
                setPage={setPage}
                page={page}
                pagination={true}
                hideFooterPagination={false}
                filterMode={"server"}
                rowHeight={120}
                rowCount={Number.MAX_VALUE}
                // hideDisplayRows={"none"}
                getRowId={(row) => row.id}
            />

        </>

    )
}

export default Invoice;


const UploadInvoice = ({ prop, handleClose, setReload, setLoadingApprove }) => {
    const { enqueueSnackbar } = useSnackbar();
    const methods = useForm({
        resolver: yupResolver(
            Yup.object().shape({
                remark: Yup.string().required("Please provide remark"),
                file: Yup.mixed().required('Please select file')
            })
        ),
        defaultValues: {
            remark: '',
        }
    });

    const { handleSubmit, reset } = methods;

    const onSubmit = async (data) => {
        setLoadingApprove(true)
        let formData = new FormData()
        formData.append('supportingDoc', data?.file[0])
        formData.append('remark', data?.remark)
        formData.append('action', "EINVOICEUPLOAD")
        formData.append('reportKey', prop.reportKey)
        try {
            await post(apiConstants.UPLOAD_EINVOICE, formData).then((res) => {
                setLoadingApprove(false)
                if (res.data.status === "SUCCESS") {
                    enqueueSnackbar("Successfully Uploaded", { variant: 'success' })
                } else {
                    enqueueSnackbar(res.data?.errorMsg ? res.data?.errorMsg : 'Some error occurred', { variant: 'error' })
                }
                handleClose()
                setReload(reload => reload + 1)
            })
            reset()
        } catch (err) {
            setLoadingApprove(false)
            handleClose()
            console.log(err);
            enqueueSnackbar("Some error occurred", { variant: 'error' })
        }
    }
    return (
        <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
            <Grid container spacing={2} alignItems="center" sx={{ mb: 2 }}>
                <Grid item xs={12} md={6}>
                    <RHFFileField name='file' fileType={['png', 'jpg', 'jpeg', 'pdf']} />
                </Grid>
                <Grid item xs={12} md={6}>
                    <RHFTextField name='remark' label='Remark *' />
                </Grid>
                <Grid item xs={12} md={12}>
                    <LoadingButton
                        variant="contained"
                        size="medium"
                        type="submit"
                    >Submit</LoadingButton>
                    <Button onClick={() => {
                        reset({
                            remark: '',
                            file: undefined
                        });
                    }}
                        variant="contained" color='error' size="medium" sx={{ ml: 1 }}>Reset</Button>
                    <Button onClick={handleDownloadSample} variant="outlined" size="medium" sx={{ ml: 1 }}>
                        Download Sample
                    </Button>
                </Grid>
            </Grid>
        </FormProvider>)
}

export { UploadInvoice }


const ManualUploadInvoice = ({ handleClose, setReload }) => {
    const { enqueueSnackbar } = useSnackbar();
    const months = [
        { label: 'January', value: 1 }, { label: 'February', value: 2 }, { label: 'March', value: 3 },
        { label: 'April', value: 4 }, { label: 'May', value: 5 }, { label: 'June', value: 6 },
        { label: 'July', value: 7 }, { label: 'August', value: 8 }, { label: 'September', value: 9 },
        { label: 'October', value: 10 }, { label: 'November', value: 11 }, { label: 'December', value: 12 }
    ];

    const methods = useForm({
        resolver: yupResolver(
            Yup.object().shape({
                merchant: Yup.string().required("Please select merchant"),
                invoiceYear: Yup.number().typeError("Please enter a valid year").required("Please enter invoice year"),
                invoiceMonth: Yup.number().typeError("Please select invoice month").required("Please select invoice month"),
                totalInvoicedOrders: Yup.number().typeError("Please enter a valid number").required("Please enter total invoiced orders"),
                totalInvoiceValue: Yup.number().typeError("Please enter a valid amount").required("Please enter total invoice value"),
                // remark: Yup.string().required("Please provide remark"),
                file: Yup.mixed().required("Please select file"),
            })
        ),
        defaultValues: {
            merchant: '',
            invoiceYear: '',
            invoiceMonth: '',
            totalInvoicedOrders: '',
            totalInvoiceValue: '',
            remark: '',
        }
    });

    const { handleSubmit, reset } = methods;
    const [submitting, setSubmitting] = useState(false);

    const onSubmit = async (data) => {
        setSubmitting(true);
        let formData = new FormData();
        formData.append('file', data.file[0]);
        formData.append('merchantRef', data.merchant);
        formData.append('invoiceYear', data.invoiceYear);
        formData.append('invoiceMonth', data.invoiceMonth);
        formData.append('totalInvoicedOrders', data.totalInvoicedOrders);
        formData.append('totalInvoiceValue', data.totalInvoiceValue);
        formData.append('remark', data.remark);
        try {
            const res = await post(apiConstants.FINANCE_UPLOAD_INVOICE, formData);
            if (res?.data?.status === "SUCCESS") {
                enqueueSnackbar("Successfully Uploaded", { variant: 'success' });
                setReload(r => r + 1);
                handleClose();
                reset();
            } else {
                enqueueSnackbar(res.data?.errorMsg || 'Some error occurred', { variant: 'error' });
            }
        } catch (err) {
            console.log(err);
            enqueueSnackbar("Some error occurred", { variant: 'error' });
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
            <Grid container spacing={2} sx={{ mb: 2, mt: 1 }}>
                <Grid item xs={12} md={4}>
                    <MerchantFilterCached required />
                </Grid>
                <Grid item xs={12} md={4}>
                    <RHFTextField name='invoiceYear' label='Invoice Year *' placeholder='e.g. 2026' />
                </Grid>
                <Grid item xs={12} md={4}>
                    <RHFSelectField name='invoiceMonth' label='Invoice Month *' options={months} width='100%' />
                </Grid>
                <Grid item xs={12} md={4}>
                    <RHFTextField name='totalInvoicedOrders' label='Total Invoiced Orders *' placeholder='e.g. 100' />
                </Grid>
                <Grid item xs={12} md={4}>
                    <RHFTextField name='totalInvoiceValue' label='Total Invoice Value *' placeholder='e.g. 100000' />
                </Grid>
                <Grid item xs={12} md={4}>
                    <RHFTextField name='remark' label='Remark' placeholder='e.g. Manual reconciliation for March 2026' />
                </Grid>
                <Grid item xs={12} md={6}>
                    <RHFFileField name='file' fileType={['csv']} />
                </Grid>
                <Grid item xs={12}>
                    <LoadingButton variant="contained" size="medium" type="submit" loading={submitting}>Submit</LoadingButton>
                    <Button onClick={() => reset()} variant="contained" color='error' size="medium" sx={{ ml: 1 }}>Reset</Button>
                    <Button onClick={handleDownloadSample} variant="outlined" size="medium" sx={{ ml: 1 }}>Download Sample</Button>
                </Grid>
            </Grid>
        </FormProvider>
    );
};

function parseCsvLine(line) {
    const cells = [];
    let cur = '';
    let inQuotes = false;
    for (let i = 0; i < line.length; i++) {
        const c = line[i];
        if (inQuotes) {
            if (c === '"' && line[i + 1] === '"') { cur += '"'; i++; }
            else if (c === '"') { inQuotes = false; }
            else { cur += c; }
        } else {
            if (c === ',') { cells.push(cur); cur = ''; }
            else if (c === '"') { inQuotes = true; }
            else { cur += c; }
        }
    }
    cells.push(cur);
    return cells;
}

const UploadCorrections = ({ prop, handleClose, setReload }) => {
    const { enqueueSnackbar } = useSnackbar();
    const [submitting, setSubmitting] = useState(false);
    const [rejection, setRejection] = useState(null); // { message, url, rows, parseError }
    const [loadingReport, setLoadingReport] = useState(false);

    const methods = useForm({
        resolver: yupResolver(
            Yup.object().shape({
                file: Yup.mixed().required('Please select file'),
            })
        ),
    });

    const { handleSubmit, reset } = methods;

    const fetchAndParseErrorReport = async (url) => {
        setLoadingReport(true);
        try {
            const csvRes = await fetch(url);
            const text = await csvRes.text();
            const lines = text.split(/\r?\n/).filter(l => l.length > 0);
            const dataLines = lines.length > 0 && /awb/i.test(lines[0]) ? lines.slice(1) : lines;
            const rows = dataLines.map(parseCsvLine).map(cells => ({
                awb: cells[0] || '',
                error: cells.slice(1).join(',') || '',
            }));
            return { rows, parseError: null };
        } catch (e) {
            console.error('Failed to fetch error report', e);
            return { rows: [], parseError: e?.message || 'Failed to load error report' };
        } finally {
            setLoadingReport(false);
        }
    };

    const onSubmit = async (data) => {
        if (!prop?.reportKey || !prop?.merchantRef) {
            enqueueSnackbar('Missing invoice context — cannot upload corrections', { variant: 'error' });
            return;
        }
        setSubmitting(true);
        const formData = new FormData();
        formData.append('file', data.file[0]);
        formData.append('reportKey', prop.reportKey);
        formData.append('merchantOid', prop.merchantRef);

        try {
            const res = await post(apiConstants.INVOICE_CORRECTIONS_UPLOAD, formData);
            const respObj = res?.data?.responseObj;
            if (res?.data?.status === 'SUCCESS' && respObj?.rejected) {
                const url = respObj.errorReportUrl;
                const message = respObj.rejectionMessage || 'CSV validation failed — see error report for details';
                enqueueSnackbar(message, { variant: 'warning' });
                let parsed = { rows: [], parseError: null };
                if (url) parsed = await fetchAndParseErrorReport(url);
                setRejection({ message, url, rows: parsed.rows, parseError: parsed.parseError });
            } else if (res?.data?.status === 'SUCCESS') {
                enqueueSnackbar('Corrections uploaded successfully', { variant: 'success' });
                setReload(r => r + 1);
                reset();
                setRejection(null);
                handleClose();
            } else {
                enqueueSnackbar(res?.data?.errorMsg || res?.data?.message || 'Some error occurred', { variant: 'error' });
            }
        } catch (err) {
            console.log(err);
            enqueueSnackbar(err?.response?.data?.errorMsg || err?.response?.data?.message || 'Some error occurred', { variant: 'error' });
        } finally {
            setSubmitting(false);
        }
    };

    const handleTryAgain = () => {
        setRejection(null);
        reset({ file: undefined });
    };

    if (rejection) {
        return (
            <Box sx={{ mt: 1 }}>
                <Alert severity="warning" sx={{ mb: 2 }}>
                    <AlertTitle>Upload Rejected</AlertTitle>
                    {rejection.message}
                </Alert>

                {rejection.parseError && (
                    <Alert severity="info" sx={{ mb: 2 }}>
                        Could not load the error report inline ({rejection.parseError}). Use the download button to view it.
                    </Alert>
                )}

                {rejection.rows.length > 0 && (
                    <>
                        <Typography variant="subtitle2" sx={{ mb: 1 }}>
                            {rejection.rows.length} row{rejection.rows.length === 1 ? '' : 's'} failed validation:
                        </Typography>
                        <TableContainer component={Paper} sx={{ mb: 2, maxHeight: 360 }}>
                            <Table size="small" stickyHeader>
                                <TableHead>
                                    <TableRow>
                                        <TableCell sx={{ fontWeight: 600, width: '40%' }}>AWB Number</TableCell>
                                        <TableCell sx={{ fontWeight: 600 }}>Error</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {rejection.rows.map((r, i) => (
                                        <TableRow key={`${r.awb}_${i}`} hover>
                                            <TableCell sx={{ fontFamily: 'monospace' }}>{r.awb}</TableCell>
                                            <TableCell>{r.error}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </>
                )}

                <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                    <Button variant="contained" onClick={handleTryAgain}>Try Again</Button>
                    {rejection.url && (
                        <Button variant="outlined" onClick={() => window.open(rejection.url)}>
                            Download Error Report
                        </Button>
                    )}
                    <Button variant="outlined" color="inherit" onClick={handleClose}>Close</Button>
                </Box>
            </Box>
        );
    }

    return (
        <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
            <Grid container spacing={2} alignItems="center" sx={{ mb: 2, mt: 1 }}>
                <Grid item xs={12}>
                    <Typography variant="body2" color="text.secondary">
                        Upload a CSV with the corrections. Required headers: <code>AWB NUMBER</code>, <code>Reason for Change</code>. Provide either FWD (<code>Freight Cost Total WithOutTax</code>, <code>Freight Tax</code>) or RTO (<code>RTO Freight Cost without TAX</code>, <code>RTO Freight TAX</code>) amounts — both are optional and may be supplied independently.
                    </Typography>
                </Grid>
                <Grid item xs={12} md={8}>
                    <RHFFileField name='file' fileType={['csv']} />
                </Grid>
                <Grid item xs={12}>
                    <LoadingButton variant="contained" size="medium" type="submit" loading={submitting || loadingReport}>Submit</LoadingButton>
                    <Button onClick={() => reset({ file: undefined })} variant="contained" color='error' size="medium" sx={{ ml: 1 }}>Reset</Button>
                    <Button onClick={handleDownloadCorrectionsSample} variant="outlined" size="medium" sx={{ ml: 1 }}>
                        Download Sample
                    </Button>
                </Grid>
            </Grid>
        </FormProvider>
    );
};

export { UploadCorrections };

function handleDownloadCorrectionsSample() {
    getDownload(`${apiConstants.BASE_LOCAL}${apiConstants.DOWNLOAD_SAMPLE_FILE}?fileName=MERCHANT_INVOICE_CORRECTIONS_UPLOAD_CSV`)
        .then((response) => {
            const href = URL.createObjectURL(new Blob([response.data], { type: "application/octet-stream" }));
            const link = document.createElement("a");
            link.href = href;
            link.setAttribute("download", "merchant-invoice-corrections-sample.csv");
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(href);
        })
        .catch((err) => console.error(err));
}

function handleDownloadSample() {
    getDownload(`${apiConstants.BASE_LOCAL}${apiConstants.DOWNLOAD_SAMPLE_FILE}?fileName=FINANCE_UPLOAD_INVOICE_SAMPLE`)
        .then((response) => {
            const href = URL.createObjectURL(new Blob([response.data], { type: "application/octet-stream" }));
            const link = document.createElement("a");
            link.href = href;
            link.setAttribute("download", "finance-upload-invoice-sample.csv");
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(href);
        })
        .catch((err) => console.error(err));
}